import { toFixedRoundDown } from "./to-fixed-round-down"

const MAX_DISPLAY_DECIMALS = 6

/**
 * Formats a token value for display in the SuperVoter optimization engine.
 * Uses min(token.decimals, 6) as maximum decimal places; trims trailing zeros.
 */
export function formatTokenOptimizationValue(value: string, decimals: number): string {
  if (!value) return "—"

  const maxDecimals = Math.min(decimals, MAX_DISPLAY_DECIMALS)
  const fixed = toFixedRoundDown(value, maxDecimals) ?? "—"
  return fixed.replace(/\.0+$/, "").replace(/(\.\d*[1-9])0+$/, "$1")
}
